<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="validate()" class="btn fixed_btn">Save</button>

      <div class="card" v-if="address">
        <div class="controls">
          <img
            @click="handleDelete"
            class="action clickable"
            style="width: 30px; float:right; cursor:pointer"
            src="@/assets/img/delete.svg"
          />
        </div>
        <h3>Address</h3>
        <google-api :inputAddress="address" @autoCompleteAddress="autoCompleteAddress" />
        <div class="inputs">
          <div class="btns left">
            <button @click="validate()" class="btn round-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import GoogleAddress from "@/components/GoogleAddress.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  components: {
    "google-api": GoogleAddress
  },
  data() {
    return {
      address: {
        name: "",
        email: "",
        phone: "",
        address_1: "",
        address_2: "",
        address_3: "",
        slug: "",
        city: "",
        state: "",
        country: "United States",
        zip: "",
        employee_count: 0,
        created_at: Date.now()
      }
    };
  },
  created() {
    return this.$bind(
      "address",
      db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("locations")
        .doc(this.$route.params.id)
    ).then(address => {
      if (address === null) {
        let email = this.$store.state.user_doc.email;
        this.address = Object.assign(
          {},
          {
            name: "",
            email,
            phone: "",
            address_1: "sadasdasdasd",
            address_2: "",
            address_3: "",
            city: "",
            state: "",
            country: "United States",
            zip: "",
            employee_count: 0,
            created_at: Date.now()
          }
        );
      }
    });
  },

  methods: {
    validate() {
      this.address.slug = this.address.name
        .split(" ")
        .join("_")
        .toLowerCase();
      let valid = true;
      let location = this.address;
      for (let key in location) {
        if (key !== "address_2" && key !== "address_3" && key !== "ignore") {
          if (!location[key]) {
            valid = false;
          }
        }
      }

      if (valid) {
        this.save();
      } else {
        Swal.fire("Please fill in all required fields");
      }
    },
    save() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false
      });
      return Promise.resolve()
        .then(() => {
          if (this.address.id) {
            return this.$firestoreRefs.address.set(this.address, {
              merge: true
            });
          } else {
            const checkLimitAndCreate = functions.httpsCallable(
              "checkLimitAndCreate"
            );
            return checkLimitAndCreate({
              path: this.$firestoreRefs.address.path,
              field: "locations",
              payload: this.address
            });
          }
        })
        .then(() => {
          loader.hide();
          return Swal.fire("Location has been Saved");
        })
        .then(() => {
          return this.goTo("/locations");
        })
        .catch(err => {
          loader.hide();
          Swal.fire("Error", err.message, "error");
        });
    },
    autoCompleteAddress(payload) {
      this.address = payload;
    },
    handleDelete() {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("locations")
            .doc(this.$route.params.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The page has been deleted.", "success");
              this.goTo("/locations");
            });
        }
      });
    }
  }
};
</script>

<style></style>
